import React from 'react'
import CTA from './CTA'
import './Home.css'
import MyImg from '../../assets/portfolioImg.png'
import HomeSocials  from './HomeSocials'
const Home = () => {
  return (
    <header>
      <div className="container header_container">
        <h5>Hello I'm</h5>
        <h1 className='my-name'>Krishna Kumar Gupta</h1>
        <h5 className='text-light'>
          Fullstack Web Developer
        </h5>
        <CTA/>
        <HomeSocials/>

    <div className="me">
      <img src={MyImg} alt="MyImg" />
    </div>

    <a href="#contact" className='scroll_down'>
Scroll Down
    </a>
      </div>
    </header>
  )
}

export default Home